/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserMessageRequest,
} from '../models/index';
import {
    UserMessageRequestFromJSON,
    UserMessageRequestToJSON,
} from '../models/index';

export interface AcceptUserMessageRequest {
    userMessageRequest: UserMessageRequest;
}

/**
 * 
 */
export class UserMessageApi extends runtime.BaseAPI {

    /**
     */
    async acceptUserMessageRaw(requestParameters: AcceptUserMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'userMessageRequest',
                'Required parameter "userMessageRequest" was null or undefined when calling acceptUserMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user-message`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMessageRequestToJSON(requestParameters['userMessageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async acceptUserMessage(requestParameters: AcceptUserMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptUserMessageRaw(requestParameters, initOverrides);
    }

}
